var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{attrs:{"href":_vm.props.href,"target":"_blank","rel":"noopener"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }